import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { isMysteryShopShopper } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import { useEditShopRequestModalContext } from './EditShopRequestModalContext';
import ShopRequestStatusSelector from '../ShopRequestStatusSelector';

const Label = styled(Typography.Text)`
  flex-shrink: 0;
  font-family: var(--font-bold);
  white-space: nowrap;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

const EditShopRequestModalStatus = () => {
  const { shopRequest, setShopRequest } = useEditShopRequestModalContext();
  const { currentUser } = useAppSelector((state) => state.auth);
  const isShopRequestSalesperson = isMysteryShopShopper(currentUser);
  const disabledStatusSelector =
    Boolean(isShopRequestSalesperson) && currentUser?.PAUser_Id !== shopRequest?.shopper?.userId;

  const handleStatusChange = (status: number) => {
    if (shopRequest) {
      setShopRequest({ ...shopRequest, status });
    }
  };

  return (
    <Container>
      <Label>Status</Label>
      <ShopRequestStatusSelector
        shopRequest={shopRequest!}
        disabled={disabledStatusSelector}
        onChange={handleStatusChange}
        dataTestId="sr-modal-status-dropdown"
      />
    </Container>
  );
};

export default EditShopRequestModalStatus;
